import styled from 'styled-components';

const StyledSetAllocation = styled.form`
    box-shadow: 0px 0px 10px silver;
    padding: 30px 25px;
    border-radius: 20px;
    margin-bottom: 40px;

    &.customType {
        .getAvailableAmount {
           align-items: initial;

           .allocationTypeTable {
            margin-top: 32px;
           }

            .formSection2 {
                display: flex;
                flex-direction: column;
                margin-top: 10px;
                flex: 1 1 0;
                justify-content: space-between;
                align-items: flex-end;

                .formInputs {
                    width: 100%;
                }

                .btn {
                    width: max-content;
                }
            }  
        }
    }
 
    .formInputs {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        gap: 20px;

        .inputGroup {
            display: flex;
            flex-direction: column;
            flex: 1 1 0;

            &.addressField {
                width: 450px;
                flex: initial;
            }

            &.invalid {
                input,
                select {
                    border: 2px solid;
                    animation: invalidInput 1s linear infinite;
                }
                label {
                    animation: invalidLabel 1s linear infinite;
                }
            }

            label {
                transition: all ease-out 0.2s;
                font-size: 14px;
                font-weight: 600;
                padding: 0 5px;
                margin-bottom: 2px;
                text-transform: uppercase;
            }

            select {
                appearance: none;
                background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
                background-repeat: no-repeat;
                background-position: right 1rem center;
                background-size: 1em;
            }

            input,
            select {
                transition: all ease-out 0.2s;

                &:disabled {
                    background-color: var(--light-gray);
                    border: 1.5px solid var(--gray);
                }
            }

            @keyframes invalidInput {
                0% {
                    border-color: rgba(255, 0, 140, 0.4);
                }
                50% {
                    border-color: rgba(255, 0, 140, 1);
                }
                100% {
                    border-color: rgba(255, 0, 140, 0.4);
                }
            }

            @keyframes invalidLabel {
                0% {
                    color: rgba(255, 0, 140, 0.4);
                }
                50% {
                    color: rgba(255, 0, 140, 1);
                }
                100% {
                    color: rgba(255, 0, 140, 0.4);
                }
            }
        }
    }

    .getAvailableAmount {
        display: flex;
        align-items: flex-end;
        gap: 20px;
        justify-content: space-between;

        .allocationTypeTable {
            width: 450px;
            margin-top: 15px;
            border: 1px solid rgba(255, 0, 140, 0.4);
            border-radius: 20px;
            padding: 10px 15px;

            .tableRow {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #ff008c40;
                padding: 5px 0;
                
                &:last-of-type {
                    border-bottom: none;
                }
            }
        }

        .btn {
            display: block;
            text-transform: uppercase;
            font-size: 17px;
            font-weight: 500;
        }
    }
`;

export default StyledSetAllocation;
